import React from 'react';
import { Badge } from 'react-bootstrap';
import { badgeTextFor } from '@/shared/utils/badgeText';
import { decisionKey, pillFor } from '@/shared/utils/statusPills';

/**
 * The one status pill. `family` picks the map in shared/utils/statusPills.js
 * and `value` the entry. The 'decision' family takes the whole decision as
 * `decision` instead; a request takes `application` so a revision the
 * faculty member started reads "Being revised". `pill` is an entry already
 * worked out from those maps ({ bg, label }), for a status that adds a count
 * to the map's wording, such as "Approved: 3 LAs".
 */
function StatusPill({
    family,
    value,
    decision,
    application,
    pill = null,
    className = '',
}) {
    const { bg, label } =
        pill ||
        pillFor(family, family === 'decision' ? decisionKey(decision) : value, {
            application,
        });
    return (
        <Badge
            bg={bg}
            text={badgeTextFor(bg)}
            className={`text-nowrap ${className}`.trim()}
        >
            {label}
        </Badge>
    );
}

export default StatusPill;
